// Clean Supabase client - no vendor chunk naming collisions
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

// Environment variables with fallbacks for development
const url = import.meta.env.VITE_SUPABASE_URL || 'https://hgahzqtfmxnjfhkuciqr.supabase.co';
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhnYWh6cXRmbXhuamZoa3VjaXFyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk2NTM2MjksImV4cCI6MjA2NTIyOTYyOX0.Jr4eCJqdWH75yS0RT9TEYChKRrRW4pnEbEXNoanHrgM';

if (!url || !anon) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

console.log('Initializing Supabase client with:', { 
  url,
  key: `${anon.substring(0, 10)}...`
});

export const supabase = createClient<Database>(url, anon, {
  auth: {
    storage: window.localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
  },
  global: {
    headers: {
      'Cache-Control': 'no-store, no-cache, must-revalidate, proxy-revalidate',
    },
    fetch: (url, options = {}) => {
      return fetch(url, {
        ...options,
        // Add timeout and retry logic
        signal: AbortSignal.timeout(30000), // 30 second timeout
      }).catch(error => {
        // Log network errors for debugging
        console.warn('Supabase network error:', error.message);
        throw error;
      });
    },
  },
  // Performance optimization for data caching
  realtime: {
    timeout: 30000, // 30 seconds
  },
});

export default supabase;

console.log('Supabase client initialized');